// Let's get things done quickly by this hacky way first
const stage = process.env.REACT_APP_ENV || 'development';

let environment: {
  STAGE: string;
  SENTRY_DSN: string;
  SENTRY_ENABLED: boolean;
  API: {
    TIMEOUT: number;
    HOST: string;
  };
  GOOGLE_CLIENT_ID: string;
  PUSHER: {
    APP_KEY: string;
    WS_HOST?: string;
    WS_PORT?: number;
    WSS_HOST?: string;
    WSS_PORT?: number;
    FORCE_TLS?: boolean;
    ENCRYPTED?: boolean;
    DISABLE_STATS?: boolean;
    ENABLED_TRANSPORTS: string[];
    AUTH_ENDPOINT: string;
  };
  GOOGLE_MAP_API_KEY: string;
  METABASE_SITE_URL: string;
  METABASE_KEY: string;
  GOOGLE_REDIRECT_URI?: string;
  GOOGLE_ANALYTICS_MEASUREMENT_ID: string;
  GOOGLE_ANALYTICS_ELEVATE_MEASUREMENT_ID: string;
  GOOGLE_ANALYTICS_ENABLED: boolean;
  GTM_ID?: string;
};
switch (stage) {
  case 'production':
    environment = {
      STAGE: stage,
      SENTRY_DSN: 'https://901603312a3801c2807513aac1700ca1@o983136.ingest.sentry.io/4506414484291584',
      API: {
        TIMEOUT: 60000,
        HOST: 'https://api.tryelevate.sg',
      },
      SENTRY_ENABLED: true,
      GOOGLE_CLIENT_ID: '946453602238-u5ff317jacm4mk45a3cc52rihogn9bg9.apps.googleusercontent.com',
      PUSHER: {
        APP_KEY: 'pusher-tryelevate.sghFMgkvL25czU9',
        WS_HOST: 'pusher.tryelevate.sg',
        WS_PORT: 80,
        WSS_HOST: 'pusher.tryelevate.sg',
        WSS_PORT: 443,
        FORCE_TLS: true,
        ENCRYPTED: false,
        DISABLE_STATS: false,
        ENABLED_TRANSPORTS: ['wss', 'ws'],
        AUTH_ENDPOINT: 'https://api-admin.tryelevate.sg/broadcasting/auth',
      },
      GOOGLE_MAP_API_KEY: 'AIzaSyBOdpPUJPzutcHJ7LWjMu4T7wfLp5kKBwM',
      METABASE_SITE_URL: 'https://metabase.tryelevate.sg',
      METABASE_KEY: 'xxx',
      GOOGLE_ANALYTICS_MEASUREMENT_ID: 'G-HHXYSC8P22',
      GOOGLE_ANALYTICS_ELEVATE_MEASUREMENT_ID: 'G-V10Z6HR2BC',
      GOOGLE_ANALYTICS_ENABLED: true,
      GTM_ID: 'GTM-N9T97P6N',
    };
    break;

  case 'staging':
    environment = {
      STAGE: stage,
      SENTRY_DSN: 'https://901603312a3801c2807513aac1700ca1@o983136.ingest.sentry.io/4506414484291584',
      API: {
        TIMEOUT: 60000,
        HOST: 'https://stg-api.tryelevate.sg',
      },
      SENTRY_ENABLED: true,
      GOOGLE_CLIENT_ID: '946453602238-e1kbcov3mo8gmg4g60ao8md2l2giur4k.apps.googleusercontent.com',
      PUSHER: {
        APP_KEY: 'stg-soketi-key',
        WS_HOST: 'stg-soketi.tryelevate.sg',
        WS_PORT: 80,
        WSS_HOST: 'stg-soketi.tryelevate.sg',
        WSS_PORT: 443,
        FORCE_TLS: true,
        ENCRYPTED: false,
        DISABLE_STATS: false,
        ENABLED_TRANSPORTS: ['wss', 'ws'],
        AUTH_ENDPOINT: 'https://api-admin.tryelevate.sg/broadcasting/auth',
      },
      GOOGLE_MAP_API_KEY: 'AIzaSyBOdpPUJPzutcHJ7LWjMu4T7wfLp5kKBwM',
      METABASE_SITE_URL: 'https://metabase.tryelevate.sg',
      METABASE_KEY: 'xxx',
      // GOOGLE_REDIRECT_URI:
      //   'eyJpdiI6IjBkdUVNT04veHdxc2RWdDdYbG1XdHc9PSIsInZhbHVlIjoiTllsQXB5WWxkQkxTcnZSenJVZHdsYTR6VEZCVXpyOHJ0RmJyckdMSExWZGYzeU9CVWNPOTVBdmJXR0o3OXZrQyIsIm1hYyI6IjE1ZjM0NjBiZmMyN2FmNzcwNDgzMGU3OTJiNGVlNzgxYzI1YjFlOWE3NmQ3MjJlZWVhMWJiYTA2OWM0OWFkNTciLCJ0YWciOiIifQ==',
      // GOOGLE_ANALYTICS_ENABLED: false,
      // GOOGLE_ANALYTICS_MEASUREMENT_ID: '',
      GOOGLE_ANALYTICS_MEASUREMENT_ID: 'G-SQKPF95X8W',
      GOOGLE_ANALYTICS_ELEVATE_MEASUREMENT_ID: 'G-F1SRQ34368',
      GOOGLE_ANALYTICS_ENABLED: false,
    };
    break;

  case 'test':
  case 'development':
  default:
    environment = {
      STAGE: stage,
      SENTRY_DSN: '',
      API: {
        TIMEOUT: 60000,
        HOST: 'https://stg-api.tryelevate.sg',
      },
      SENTRY_ENABLED: false,
      GOOGLE_CLIENT_ID: '946453602238-e1kbcov3mo8gmg4g60ao8md2l2giur4k.apps.googleusercontent.com',
      PUSHER: {
        APP_KEY: 'stg-soketi-key',
        WS_HOST: 'stg-soketi.tryelevate.sg',
        WS_PORT: 80,
        WSS_HOST: 'stg-soketi.tryelevate.sg',
        WSS_PORT: 443,
        FORCE_TLS: true,
        ENCRYPTED: false,
        DISABLE_STATS: false,
        ENABLED_TRANSPORTS: ['wss', 'ws'],
        AUTH_ENDPOINT: 'https://api-admin.tryelevate.sg/broadcasting/auth',
      },
      GOOGLE_MAP_API_KEY: 'AIzaSyBOdpPUJPzutcHJ7LWjMu4T7wfLp5kKBwM',
      METABASE_SITE_URL: 'https://metabase.tryelevate.sg',
      METABASE_KEY: 'xxx',
      // GOOGLE_REDIRECT_URI:
      //   'eyJpdiI6Ikx3cGRhaWRtdVVsSC9iSUFiaDZyQXc9PSIsInZhbHVlIjoiSW1qVmVnaHFDVFN3Q3UrKzRKbWxDS3BBZUd6UkZmQVZtN2ZIWVl6WEttVT0iLCJtYWMiOiIzYjRmZjFlNDVkYWNlMWUxZDE3NjIwZGU2NWQ5ZGE5MjMwZmY5ZDU0Yjg2YjMxZDlkOGM3YTg3MDY2MTNkZDg3IiwidGFnIjoiIn0=',
      GOOGLE_ANALYTICS_ENABLED: false,
      GOOGLE_ANALYTICS_MEASUREMENT_ID: '',
      GOOGLE_ANALYTICS_ELEVATE_MEASUREMENT_ID: '',
    };
    break;
}

export default environment;
